/**
 * Smart-matching guards for client booking removal flows.
 * @param {object|undefined} pattern - A single element from `booking.shiftPattern`.
 */

export function isShiftSmartMatchingActive(pattern) {
  const mode = pattern?.smartMatchingActiveMode;
  if (mode == null) return false;
  return String(mode).trim() !== "";
}

export function hasAnyShiftSmartMatchingActive(shiftPattern) {
  return (Array.isArray(shiftPattern) ? shiftPattern : []).some(
    isShiftSmartMatchingActive
  );
}

export function formatSmartMatchingMode(mode) {
  if (mode == null || String(mode).trim() === "") return "Smart matching";
  return String(mode)
    .trim()
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * @param {object|undefined} pattern - Shift pattern from booking detail.
 * @param {{ anyShiftActive?: boolean }} options
 */
export function getShiftRemovalRestrictions(pattern, { anyShiftActive = false } = {}) {
  if (isShiftSmartMatchingActive(pattern)) {
    return { blockAll: true, blockWorkersOnly: true };
  }
  if (anyShiftActive) {
    return { blockAll: false, blockWorkersOnly: true };
  }
  return { blockAll: false, blockWorkersOnly: false };
}

/**
 * @param {Array} shiftPattern - `booking.shiftPattern`
 * @param {object} payload - `{ cancelBooking, shifts }` from remove flow
 */
export function validateRemovalAgainstSmartMatching(shiftPattern, payload) {
  const patterns = Array.isArray(shiftPattern) ? shiftPattern : [];
  const anyActive = hasAnyShiftSmartMatchingActive(patterns);
  const shifts = Array.isArray(payload?.shifts) ? payload.shifts : [];

  for (const entry of shifts) {
    const idx = entry?.shiftIndex;
    const pattern = patterns[idx];
    if (isShiftSmartMatchingActive(pattern)) {
      return {
        valid: false,
        message:
          "Removals are disabled while smart matching is running on that shift.",
      };
    }
    if (anyActive && Array.isArray(entry.workers) && entry.workers.length > 0) {
      return {
        valid: false,
        message:
          "Worker removals are disabled while smart matching is running on another shift.",
      };
    }
  }

  return { valid: true, message: null };
}
